import React, { Component } from "react";
import "../../App.css";
import FoundationContent from "../FoundationContent";
import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import "../../MyComponents/pages/FoundationContent.css";
// import SSOLogin from '../../SSOLogin';
// import { msalApp } from '../../utils/MSUtils';
import FoundationNavBar from "../FoundationNavBar";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./MediaCarousel.css";

function NextArrow(props) {
  const { onClick } = props;
  return (
    <div
      style={{
        position: "absolute",
        right: "15px",
        top: "50%",
        transform: "translateY(-50%)",
        zIndex: 20,
        fontSize: "30px",
        background: '#7500c0',
        width: "50px",
        height: "100px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#fff",
        cursor: "pointer",
      }}
      onClick={onClick}
    >
      ❯
    </div>
  );
}

function PrevArrow(props) {
  const { onClick } = props;
  return (
    <div
      style={{
        position: "absolute",
        left: "15px",
        top: "50%",
        transform: "translateY(-50%)",
        zIndex: 20,
        fontSize: "30px",
        background: '#7500c0',
        width: "50px",
        height: "100px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#fff",
        cursor: "pointer",
      }}
      onClick={onClick}
    >
      ❮
    </div>
  );
}

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />
};

function foundationComponent() {
  return (
    <>
      <div className="main-container foundation-container" id="main">
        <title>Foundation - Home</title>
        <p className="sr-only">Phase of Tech Expressway-Level1</p>
        <img
          src="/images/Foundation/foundation.png"
          alt="banner-image"
          className="banner-img"
        />
        <FoundationNavBar />
        <div className="foundation-phase">
          <p>
            The <strong>FOUNDATION</strong> phase helps entry level hires
            {/* a new joiner (ASE) */} to bridge the skill gaps in terms of the
            role and seamlessly move into <strong>JOB READINESS</strong> phase.
            This seamless transition is enabled through <strong>Primers</strong>
            .
          </p>
        </div>
        {/*  <h2 className="foundation-head">
          Tech Expressway Learning Journey : <span>FOUNDATION</span>
        </h2> */}
        <h2 className="foundation-head">
          Entry Level Learning Journey : <span>FOUNDATION</span>
        </h2>
        <div className="foundation-career-box">
          {/* <figure>
            <img
              src="/images/entrylevelfoundation.png"
              alt="Tech Expressway Learning Journey"
              className="job-journey-img"
            /> */}
          {/*  <img
              src="/images/Foundation/foundation-info-first.png"
              alt="Tech Expressway Learning Journey"
              className="job-journey-img"
            /> */}
          {/* </figure> */}
          <Slider {...settings} >

            <div className="img-video-holder">
              <img
                // src="/images/Foundationupdatedimg.jpg" 
                src="/images/Infographs-new/EntryLevellatest-foundation-img.jpg" 
                alt="slide1" 
                width="100%" 
                className="all-journey-img"
               />
            </div>

            <div className="img-video-holder">
              <img
                // src="/images/Frame 13.jpg"
                src="/images/Infographs-new/EntryLevelQuantum-foundation-img.jpg"
                alt="slide2" width="100%"
                className="all-journey-img entry-level-last-img"
               />
            </div>


          </Slider>

          <br />
        </div>
        <div className="primers-wrap">
          <div className="primers-row">
            <div className="primers-box">
              <h2>
                <span>What are Primers?</span>
              </h2>
              {/* <p>Primers are foundational learning that will equip a new joiner with key <strong>role</strong> or <strong>skill</strong> specific learning, before moving on to specialized learning streams. </p> */}
              <p>
                Primers are foundational learnings that will equip new joiners
                (ASEs) with key role or skill specific learnings, before moving
                on to specialized learning streams. We have introduced a dynamic
                approach to learning that adapts to your unique learning style,
                ensuring a personalized learning experience that optimizes your
                potential.
              </p>
              <h2>
                <span>Why are Primers needed?</span>
              </h2>
              {/* <p>Primers address the learning needs of the <strong>diverse talent pool</strong> coming from different educational streams.</p> */}
              <p>
                Primers helps address the learning needs of the diverse talent
                pool coming from different educational streams. The primers are
                assigned to new joiners based on their Career Track and Job
                Family.
              </p>
              {/* <h2>
                <span>How do Primers help?</span>
              </h2>
              <p>
                Primers are <strong>foundational learning</strong> assets that
                have been designed keeping the technology and functional
                learning requirements.
              </p> */}
            </div>
          </div>
          <div className="primers-row">
            <div className="primers-box">
              {/* <img
                src="/images/primers-image.jpg"
                className="foundation-img"
                alt="foundation"
              /> */}
              <img
                src="/images/Foundation/foundation-info.png"
                className="foundation-img"
                alt="foundation"
              />
            </div>
          </div>
        </div>
        <div className="right-comb">
          <p>
            The right combination of <strong>Primers</strong> helps in creating
            the baseline equivalence for all ASEs before the start of actual
            skills learning. The below table gives you an illustrative example
            of primer assignment.
          </p>
          <div className="table-wrap">
            <table>
              <tr>
                <th>Career Track</th>
                <th>Job Family</th>
                <th>Primers Assigned</th>
              </tr>
              <tr>
                <td>System Engineering</td>
                <td>Application Development</td>
                <td>
                  <ul>
                    {/* <li>Technology Foundation Primer</li> */}
                    <li>App Dev</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>System Engineering </td>
                <td>Cloud Security</td>
                <td>
                  <ul>
                    <li>Security</li>
                  </ul>
                </td>
              </tr>
              {/* <tr>
                <td>System Engineering </td>
                <td>Cloud Operations Engineering</td>
                <td>
                  <ul>
                    <li>ServiceNow</li>
                  </ul>
                </td>
              </tr> */}
              <tr>
                <td>System and Application Services</td>
                {/* <td>Cloud Operations Administration</td> */}
                <td>App/ Cloud Support</td>
                <td>
                  <ul>
                    {/* <li>Infra Support Primer</li> */}
                    <li>App Dev Prep</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>System and Application Services</td>
                {/* <td>App/Cloud Support</td> */}
                <td>Cloud Operations Administration</td>
                <td>
                  <ul>
                    {/* <li>App Dev Prep</li> */}
                    <li>Infrastructure Engineering (IE)</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>Platform Delivery</td>
                <td>Business and Technology Delivery</td>
                <td>
                  <ul>
                    {/* <li>Functional Foundation Primer</li>
                    <li>
                      One of the Functional Primers
                      (HCM/SCM/Finance/Sales/Manufacturing/CX-CRM)
                    </li> */}
                    <li>Platform Delivery (Functional)</li>
                  </ul>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div className="f_cater-cont">
          {/* <p>The Campus to Corporate (C2C) enhanced program will be assigned to every new joiner, in addition to the technology/functional foundation primer.
               Foundational primers lays the foundation for the career track and job family specific role before embarking on to skill trainings. To cater to the technical and functional skills, the Primers at a higher level have been broadly categorized into two:</p> */}
          {/* <p>
            ATCI ASE Professional Advancement Program, a structured learning
            path which is spread across 0-24 months with interventions focusing
            on Business Communication skills, Personal Productivity & Well-Being
            will be assigned to every new joiner.
          </p> */}
          <p>
            Each of the primers will have an Essentials and Elective section.
            The Essentials section is mandatory for all and will focus on
            building a strong technology/functional foundation. The Electives
            section will give the ASE a choice of key technology/functional
            areas to pick from
          </p>
          <div className="f_cards_container">
            <div className="f_cards_wrapper">
              <ul className="f_cards_items">
                <li className="f_cards_item">
                  <NavLink
                    to="/foundation-tech-primers"
                    target="blank"
                    className="cards_item_link"
                  >
                    <figure className="cards_item_picwrap">
                      <img
                        src="/images/technology-primers.jpg"
                        alt="image"
                        className="cards_item_img"
                      />
                      <h3>Technology Foundational Primers</h3>
                    </figure>
                  </NavLink>
                </li>
                <li className="f_cards_item">
                  <NavLink
                    to="/foundation-func-primers"
                    target="blank"
                    className="cards_item_link"
                  >
                    <figure className="cards_item_picwrap">
                      <img
                        src="/images/functional-primers.jpg"
                        alt="image"
                        className="cards_item_img"
                      />
                      <h3>Functional Foundational Primers</h3>
                    </figure>
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default foundationComponent;
